import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@ovComponents/2-component/dialog/dialog';

import { NetWorthWorkflowContext } from '@ovComponents/4-module/netWorthWorkflow/netWorthWorkflowContext';
import { WorkflowContext } from '@ovComponents/4-module/workflowCompletion/workflowCompletionContext';
import { Button, IconButton } from 'hephaestus/web';
import {
  ChevronLeft,
  CloseRounded as CloseRoundedIcon,
} from 'hephaestus/webIcons';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import NetWorthDetails from './netWorthDetails';
import { NetWorthSelectType } from './netWorthSelectType';

const AddNetWorthManuallyModal = ({
  open,
  onClose,
  step,
  setStep,
  onNext,
}: {
  open: boolean;
  onClose: () => void;
  step: number;
  setStep: (step: number) => void;
  onNext: () => void;
}) => {
  const { t } = useTranslation('shared');
  const { netWorthData, setNetWorthData } = useContext(NetWorthWorkflowContext);
  const { workflowData, setWorkflowData } = useContext(WorkflowContext);

  const applicableData =
    Object.keys(netWorthData).length !== 0 ? netWorthData : workflowData;
  const setApplicationContext =
    Object.keys(netWorthData).length !== 0 ? setNetWorthData : setWorkflowData;

  const goBack = () => {
    setApplicationContext({
      ...applicableData,
      netWorthData: {
        ...applicableData.netWorthData,
        netWorthStep: 1,
      },
    });
    setStep(1);
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle
        borderBottom='none'
        display='flex'
        justifyContent={step === 2 ? 'space-between' : 'end'}
      >
        {step === 2 && (
          <Button variant='text' startIcon={<ChevronLeft />} onClick={goBack}>
            {t('back')}
          </Button>
        )}
        <IconButton aria-label='close' onClick={onClose}>
          <CloseRoundedIcon fontSize='inherit' />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          py: '20px',
          width: { sm: '550px' },
        }}
      >
        {step === 1 && <NetWorthSelectType onNext={() => setStep(2)} />}
        {step === 2 && (
          <NetWorthDetails
            onNext={() => {
              onNext();
              onClose();
            }}
            setStep={setStep}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AddNetWorthManuallyModal;
